export default __webpack_public_path__ + "static/media/gwn46.c4673405.webp";